// extracted by mini-css-extract-plugin
export default {"cardContainer":"admin_cardContainer__wopMB","card":"admin_card__RyWF9"};